import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router";
import { FormInput } from "@/components/forms/FormInput";
import { FormWrapper } from "@/components/forms/FormWrapper";
import { useLogin } from "./useLogin";
import { Routes } from "@/config/routes";
import { Card, CardContent } from "@/components/ui/card";
import { AuthenticationFormHeader } from "@/components/forms/AuthenticationFormHeader";
import { FormSubmitButton } from "@/components/forms/FormSubmitButton";
import { env } from "@/config/env";

export const Login = observer(() => {
	const { t } = useTranslation();
	const { form, onSubmit, isLoading, error } = useLogin();

	const [searchParams] = useSearchParams();
	const ssoError = searchParams.get("sso_error");
	const formError = error ?? (ssoError ? { message: ssoError } : undefined);

	const ssoLoginUrl = env.ENTRA_SSO_LOGIN_URL;

	return (
		<Card>
			<AuthenticationFormHeader title={t("pages.login.title")} description={t("pages.login.description")} />
			<CardContent>
				<FormWrapper form={form} onSubmit={onSubmit} error={formError}>
					<FormInput
						name="Email"
						type="email"
						label={t("shared.forms.email.label")}
						placeholder={t("shared.forms.email.placeholder")}
						required
					/>
					<FormInput
						name="Password"
						type="password"
						label={t("shared.forms.password.label")}
						placeholder={t("shared.forms.password.placeholder")}
						required
						extraLabelElement={
							<Link
								to={Routes.Auth.ForgotPassword.path}
								tabIndex={-1}
								className="text-sm text-gray-400 underline-offset-4 hover:underline"
							>
								{t("pages.login.forgot_password_link_text")}
							</Link>
						}
					/>

					<FormSubmitButton
						isLoading={isLoading}
						buttonText={t("pages.login.button_text")}
						buttonLoadingText={t("pages.login.button_text_loading")}
					/>
				</FormWrapper>
				<a
					href={ssoLoginUrl}
					className="mt-4 w-full py-2 bg-blue-600 text-white rounded-md text-center block hover:bg-blue-700"
				>
					{t("pages.login.microsoft_sso_button_text")}
				</a>
			</CardContent>
		</Card>
	);
});
